module.exports = __webpack_public_path__ + "img/school-analytic-250.79097bdd.png";